import Swiper, {Pagination} from 'swiper';

class UpcomingEvents {
    constructor() {
        const swiper = new Swiper('.private-client__upcoming', {
            speed: 500,
            spaceBetween: 20,
            slidesPerView: 1,
            modules: [
                Pagination
            ],
            pagination: {
                el: '.upcoming-pagination',
                type: 'bullets',
                clickable: true,
                dynamicBullets: true
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    enabled: true,
                    pagination: {
                        enabled: true
                    }
                },
                720: {
                    enabled: false
                }
            }
        });

        swiper.on('breakpoint', (swiper, bp) => {
            // reinitialise slider after breakpoint
            swiper.pagination.init();
            swiper.pagination.update();
        })
    }
}

export default UpcomingEvents;
